import { LineChart, Line, XAxis, YAxis, Tooltip, ResponsiveContainer } from "recharts";

export default function TaxGraph({ data }) {
  return (
    <div className="card">
      <h2>📊 Tax vs Salary Graph</h2>

      <ResponsiveContainer width="100%" height={250}>
        <LineChart data={data}>
          <XAxis dataKey="salary" />
          <YAxis />
          <Tooltip />
          <Line type="monotone" dataKey="tax" stroke="#22c55e" />
        </LineChart>
      </ResponsiveContainer>
    </div>
  );
}